///<reference path="input-actions/action-wrapper.ts"/>

module Meevo.Components.Controls.HideInput {

    export enum VisibilityState {
        Hidden = 0,
        Visible = 1
    }

    export class InputHandler {

        private selectionStart: number;
        private selectionEnd: number;
        private action: ActionWrapper;

        private _actualValue: string;
        private _hiddenValue: string;
        private _visibilityState: VisibilityState;
        private _modelValue: string;
        private _viewValue: string;

        private get actualValue(): string {
            return this._actualValue;
        }

        private set actualValue(str: string) {
            this._actualValue = this.converter.preUpdateValue(str);
            this._modelValue = this.converter.modelValue(this.actualValue);
        }

        get modelValue() {
            return this._modelValue;
        }

        set viewValue(value: string) {
            console.log('value', value);
            this.action.setValues({
                inputValue: value,
                actualValue: this.actualValue
            });

            this.actualValue = this.action.processActualValue();

            this._viewValue = this.visibilityState === VisibilityState.Hidden ? (this._hiddenValue = this.converter.hide(this.actualValue)) : this.actualValue;
            console.log(this.actualValue, this._viewValue);
        }

        get viewValue() {
            return this._viewValue;
        }

        get visibilityState() {
            return this._visibilityState;
        }

        constructor(private input: HTMLInputElement, private converter: IStringConverter) {
            this.actualValue = '';
            this._viewValue = '';
            this._visibilityState = VisibilityState.Visible;

            input.addEventListener('input', this.onInput.bind(this));
            input.addEventListener('click', this.onClick.bind(this));
            input.addEventListener('keyup', this.onKeyUp.bind(this));

        }

        private onInput(event: InputEvent) {
            this.action = new ActionWrapper(
                event,
                this.visibilityState,
                this.selectionStart,
                this.selectionEnd
            );

            console.log(event.data, event.inputType);
            this.selectionStart = this.input.selectionStart;
            this.selectionEnd = this.input.selectionEnd;
        }

        private onClick(): void {
            this.selectionStart = this.input.selectionStart;
            this.selectionEnd = this.input.selectionEnd;
        }

        private onKeyUp() {
            this.selectionStart = this.input.selectionStart;
            this.selectionEnd = this.input.selectionEnd;
        }

        private updateInputValue() {
            this._viewValue = this.visibilityState === VisibilityState.Hidden ? (this._hiddenValue = this.converter.hide(this.actualValue)) : this.actualValue;
        }

        onOptionsChanged() {
            this.updateInputValue();
        }

        toggleVisibility() {
            this._visibilityState = this._visibilityState === VisibilityState.Visible ? VisibilityState.Hidden : VisibilityState.Visible;

            this.updateInputValue();
        }

        updateValue(newValue: any) {
            this.actualValue = this.converter.parseModelValue(newValue);
            this.updateInputValue();
        }

    }
}
